import { 
  fetchPublicMetrics, 
  fetchApprovedTestimonials, 
  fetchPublicPromotions,
  subscribePromotionsLocalSync,
  subscribeToPromotionsRealtime
} from './supabaseClient.js';


document.addEventListener('DOMContentLoaded', async () => {
  const metricGamers = document.getElementById('metric-gamers-online');
  const metricTotal = document.getElementById('metric-total-ventas');
  const metricRenovacion = document.getElementById('metric-porcentaje-renovacion');
  const metricRacha = document.getElementById('metric-racha-record');
  const metricRachaUnit = document.getElementById('metric-racha-unit');
  const testimonialsGrid = document.getElementById('dynamic-testimonios-grid');
  const testimonialsControls = document.getElementById('testimonials-controls');
  const countLabel = document.getElementById('testimonials-count-label');
  const loadMoreBtn = document.getElementById('load-more-testimonials-btn');
  const prevBtn = document.getElementById('prev-testimonials-btn');
  const nextBtn = document.getElementById('next-testimonials-btn');
  const pageIndicator = document.getElementById('testimonials-page-indicator');
  const resetBtn = document.getElementById('reset-testimonials-btn');
  const filterAllBtn = document.getElementById('filter-all-btn');
  const filter5StarsBtn = document.getElementById('filter-5stars-btn');
  const filterProofsBtn = document.getElementById('filter-proofs-btn');

  const proofModal = document.getElementById('proof-modal');
  const proofModalImg = document.getElementById('proof-modal-img');
  const proofModalTitle = document.getElementById('proof-modal-title');
  const closeProofModalBtn = document.getElementById('close-proof-modal');

  // =========================================================================
  // 1. ANIMACIÓN DE CONTADORES RETRO
  // =========================================================================
  function animateCounter(el, target, duration = 1800, isDecimal = false) {
    if (!el) return;
    const numTarget = Number(target) || 0;
    if (numTarget === 0) {
      el.textContent = isDecimal ? '0.0' : '0';
      return;
    }
    const start = 0;
    const startTime = performance.now();

    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const ease = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      const currentVal = start + (numTarget - start) * ease;

      if (isDecimal) {
        el.textContent = currentVal.toFixed(1);
      } else {
        el.textContent = Math.floor(currentVal).toLocaleString();
      }

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        if (isDecimal) {
          el.textContent = numTarget.toFixed(1);
        } else {
          el.textContent = Math.floor(numTarget).toLocaleString();
        }
      }
    }
    requestAnimationFrame(update);
  }

  // Cargar métricas en vivo (auditables y 100% reales desde Supabase)
  try {
    const metrics = await fetchPublicMetrics();
    if (metricGamers) animateCounter(metricGamers, metrics.gamers_activos_online);
    if (metricTotal) animateCounter(metricTotal, metrics.total_ventas_historicas);
    if (metricRenovacion) animateCounter(metricRenovacion, metrics.porcentaje_renovacion, 1800, true);
    if (metricRacha) {
      animateCounter(metricRacha, metrics.racha_record_comunidad);
      if (metricRachaUnit) {
        metricRachaUnit.textContent = metrics.racha_record_comunidad === 1 ? 'MES' : 'MESES';
      }
    }
  } catch (err) {
    console.warn('Fallo al cargar métricas de Supabase:', err);
  }

  // =========================================================================
  // 2. GESTOR INTELIGENTE DE TESTIMONIOS (PAGINACIÓN, FILTROS Y OPTIMIZACIÓN)
  // =========================================================================
  // Solo se cargan y muestran los testimonios reales aprobados desde Supabase/Admin
  let allTestimonials = [];
  let currentFilter = 'all'; // 'all', '5stars', 'proofs'
  let visibleCount = 3;
  let currentPage = 1;
  const pageSize = 3;
  let displayMode = 'progressive'; // 'progressive' (+3) o 'paged' (página por página)

  // Cargar testimonios aprobados de Supabase y moderación
  try {
    const supabaseTestimonials = await fetchApprovedTestimonials();
    allTestimonials = Array.isArray(supabaseTestimonials) ? supabaseTestimonials : [];
  } catch (err) {
    console.warn('Fallo al cargar testimonios aprobados:', err);
    allTestimonials = [];
  }

  function getFilteredList() {
    return allTestimonials.filter(t => {
      if (currentFilter === '5stars') {
        return (t.calificacion_estrellas || 5) >= 5;
      }
      if (currentFilter === 'proofs') {
        return !!t.comprobante_captura_url;
      }
      return true;
    });
  }

  function renderTestimonials() {
    if (!testimonialsGrid) return;

    const filtered = getFilteredList();
    const totalCount = filtered.length;

    // Estado vacío retro si no hay testimonios aprobados (ej: tras eliminarlos en el panel)
    if (totalCount === 0) {
      testimonialsGrid.innerHTML = `
        <div class="col-span-full py-12 px-6 text-center border-2 border-dashed border-purple-800/60 bg-black/50 backdrop-blur-md flex flex-col items-center justify-center space-y-3">
          <div class="pixel-font text-2xl sm:text-3xl text-purple-400">👾 [REGISTRO DE TESTIMONIOS VACÍO]</div>
          <p class="font-mono text-xs sm:text-sm text-purple-300/80 max-w-lg mx-auto leading-relaxed">
            No hay testimonios aprobados públicos en este momento. Todos los testimonios pasan por auditoría previa con comprobante verificado antes de publicarse.
          </p>
          <div class="pt-2">
            <a 
              href="feedback.html" 
              class="inline-flex items-center gap-2 px-4 py-2 border border-[#00ff41] bg-[#00ff41]/10 text-[#00ff41] font-mono text-xs font-bold hover:bg-[#00ff41] hover:text-black transition-all cursor-pointer shadow-[0_0_15px_rgba(0,255,65,0.2)]"
            >
              <span>✍️</span> <span>SÉ EL PRIMERO EN DEJAR TU OPINIÓN Y COMPROBANTE</span>
            </a>
          </div>
        </div>
      `;

      if (countLabel) {
        countLabel.textContent = `[ 📊 AUDITORÍA EN TIEMPO REAL: NO HAY TESTIMONIOS PÚBLICOS EN ESTE MOMENTO ]`;
      }
      if (pageIndicator) pageIndicator.textContent = `PÁG 0 / 0`;
      if (prevBtn) prevBtn.disabled = true;
      if (nextBtn) nextBtn.disabled = true;
      if (loadMoreBtn) loadMoreBtn.classList.add('hidden');
      if (resetBtn) resetBtn.classList.add('hidden');
      if (testimonialsControls) testimonialsControls.classList.add('hidden');
      return;
    }

    if (testimonialsControls) testimonialsControls.classList.remove('hidden');

    const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));

    let itemsToRender = [];
    if (displayMode === 'progressive') {
      itemsToRender = filtered.slice(0, visibleCount);
      currentPage = Math.ceil(itemsToRender.length / pageSize) || 1;
    } else {
      const startIndex = (currentPage - 1) * pageSize;
      itemsToRender = filtered.slice(startIndex, startIndex + pageSize);
    }

    // Renderizar tarjetas
    testimonialsGrid.innerHTML = itemsToRender.map((t, idx) => {
      const globalIndex = displayMode === 'progressive' ? idx + 1 : ((currentPage - 1) * pageSize) + idx + 1;
      const fileNumber = String(globalIndex).padStart(2, '0');
      const stars = '★'.repeat(t.calificacion_estrellas || 5);
      const fallbackImg = 'https://res.cloudinary.com/afkfwjkg/image/upload/f_auto,q_auto/v1789306843/instaplay_comprobantes/aaovr08lnwpwbch0yab0.jpg';
      let imgUrl = t.comprobante_captura_url || fallbackImg;
      if (imgUrl.includes('test.jpg')) {
        imgUrl = fallbackImg;
      }
      const initials = (t.gamertag || 'GP').replace(/[@_]/g, '').substring(0, 2).toUpperCase();

      return `
        <div class="testimonial-win reveal visible flex flex-col justify-between" style="opacity: 1; transform: translateY(0);">
          <div class="win-titlebar flex-shrink-0">
            <div class="title"><span>💬</span><span>msg_user_${fileNumber}.txt</span></div>
            <div class="win-buttons"><div class="win-btn cursor-pointer">×</div></div>
          </div>
          <div class="win-body flex flex-col justify-between flex-1 p-4 sm:p-5 overflow-hidden space-y-2">
            <div class="flex-1 flex flex-col min-h-0">
              <div class="flex items-center justify-between mb-2 flex-shrink-0">
                <div class="pixel-font text-yellow-400 text-lg">${stars} <span class="text-purple-400">[${t.calificacion_estrellas || 5}/5]</span></div>
                <span class="retro-tag green">✓ ${t.insignia_verificacion || 'PAGO_VERIFICADO'}</span>
              </div>
              <div class="testimonial-comment-box overflow-y-auto overscroll-contain pr-1.5 mb-2 flex-1 min-h-[75px] max-h-[120px] text-purple-200 leading-relaxed text-sm font-mono custom-mini-scroll">
                <span class="text-green-400">&gt;</span> "${t.testimonio_texto}"
              </div>
              <div class="flex-shrink-0 space-y-1 mb-1">
                ${t.juegos_mencionados ? `
                  <div class="text-[11px] text-[#39ff14] font-mono truncate" title="${t.juegos_mencionados}">
                    🎮 <strong>Juegos:</strong> ${t.juegos_mencionados}
                  </div>
                ` : `
                  <div class="text-[11px] text-[#39ff14]/70 font-mono truncate">
                    🎮 <strong>Juegos:</strong> Catálogo Completo Cloud
                  </div>
                `}
                ${t.dispositivo_red ? `
                  <div class="text-[10px] text-green-400/80 font-mono truncate" title="${t.dispositivo_red}">
                    ⚡ <strong>Hardware/Red:</strong> ${t.dispositivo_red}
                  </div>
                ` : `
                  <div class="text-[10px] text-green-400/60 font-mono truncate">
                    ⚡ <strong>Hardware/Red:</strong> PC / Mac / Móvil (60 FPS)
                  </div>
                `}
              </div>
            </div>

            <div class="flex-shrink-0 pt-2 border-t border-purple-900/60">
              <div class="mb-2">
                <button 
                  class="open-proof-btn w-full py-1.5 px-3 bg-[#011a07] hover:bg-[#00ff41] hover:text-black border border-[#00ff41] text-xs font-mono text-[#00ff41] transition-all flex items-center justify-center gap-2 font-bold cursor-pointer"
                  data-img="${imgUrl}"
                  data-user="${t.gamertag}"
                >
                  <span>📎</span> <span>[ VER COMPROBANTE Y CHAT REAL ]</span>
                </button>
              </div>

              <div class="border-t-2 border-dashed border-purple-600 pt-2 flex items-center gap-3">
                <div class="w-10 h-10 bg-gradient-to-br from-green-500 to-emerald-700 border-2 border-cyan-400 flex items-center justify-center pixel-font text-black font-bold text-lg flex-shrink-0">
                  ${initials}
                </div>
                <div class="min-w-0 flex-1">
                  <div class="pixel-font text-white text-lg leading-tight truncate">${t.gamertag}</div>
                  <div class="text-xs text-purple-400 truncate">${t.ciudad_pais} · Racha: ${t.racha_al_publicar || 1}M 🔥</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
    }).join('');

    // Conectar botones cosméticos de cerrar ventana
    testimonialsGrid.querySelectorAll('.win-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const win = btn.closest('.testimonial-win');
        if (win && btn.textContent.trim() === '×') {
          win.style.transition = 'opacity 0.3s, transform 0.3s';
          win.style.opacity = '0';
          win.style.transform = 'scale(0.95)';
          setTimeout(() => {
            win.style.opacity = '1';
            win.style.transform = 'scale(1)';
          }, 1500);
        }
      });
    });

    // Actualizar indicador de métricas
    if (countLabel) {
      const shownCount = itemsToRender.length;
      countLabel.textContent = `[ 📊 AUDITORÍA EN TIEMPO REAL: MOSTRANDO ${shownCount} DE ${totalCount} TESTIMONIOS VERIFICADOS ]`;
    }

    if (pageIndicator) {
      pageIndicator.textContent = `PÁG ${currentPage} / ${totalPages}`;
    }

    if (prevBtn) {
      prevBtn.disabled = currentPage <= 1;
    }
    if (nextBtn) {
      nextBtn.disabled = currentPage >= totalPages;
    }

    // Botón Cargar Más
    if (loadMoreBtn) {
      if (displayMode === 'progressive') {
        if (visibleCount >= totalCount) {
          loadMoreBtn.classList.add('hidden');
        } else {
          loadMoreBtn.classList.remove('hidden');
          const remaining = totalCount - visibleCount;
          loadMoreBtn.innerHTML = `<span>⚡ CARGAR 3 MÁS (${remaining} RESTANTES)</span>`;
        }
      } else {
        loadMoreBtn.classList.remove('hidden');
        loadMoreBtn.innerHTML = `<span>⚡ VER TODOS MODO EXPANDIDO</span>`;
      }
    }

    // Botón Resetear
    if (resetBtn) {
      if ((displayMode === 'progressive' && visibleCount > 3) || (displayMode === 'paged' && currentPage > 1)) {
        resetBtn.classList.remove('hidden');
      } else {
        resetBtn.classList.add('hidden');
      }
    }
  }

  // Controles de Paginación y Carga Progresiva
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', () => {
      const filtered = getFilteredList();
      if (displayMode === 'paged') {
        displayMode = 'progressive';
        visibleCount = 6;
      } else {
        visibleCount = Math.min(visibleCount + 3, filtered.length);
      }
      renderTestimonials();
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      if (currentPage > 1) {
        displayMode = 'paged';
        currentPage--;
        renderTestimonials();
      }
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      const filtered = getFilteredList();
      const totalPages = Math.ceil(filtered.length / pageSize);
      if (currentPage < totalPages) {
        displayMode = 'paged';
        currentPage++;
        renderTestimonials();
      }
    });
  }

  if (resetBtn) {
    resetBtn.addEventListener('click', () => {
      displayMode = 'progressive';
      visibleCount = 3;
      currentPage = 1;
      renderTestimonials();
      if (testimonialsGrid) {
        testimonialsGrid.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  }

  // Filtros interactivos
  function updateActiveFilterButton() {
    const activeClass = ['bg-[#00ff41]', 'text-black', 'border-[#00ff41]'];
    const defaultClass = ['bg-[#003300]', 'text-[#00ff41]', 'border-[#00ff41]'];

    [filterAllBtn, filter5StarsBtn, filterProofsBtn].forEach(b => {
      if (!b) return;
      b.classList.remove(...activeClass);
    });

    if (currentFilter === 'all' && filterAllBtn) filterAllBtn.classList.add(...activeClass);
    if (currentFilter === '5stars' && filter5StarsBtn) filter5StarsBtn.classList.add('bg-yellow-400', 'text-black', 'border-yellow-400');
    if (currentFilter === 'proofs' && filterProofsBtn) filterProofsBtn.classList.add('bg-cyan-400', 'text-black', 'border-cyan-400');
  }

  if (filterAllBtn) {
    filterAllBtn.addEventListener('click', () => {
      currentFilter = 'all';
      visibleCount = 3;
      currentPage = 1;
      updateActiveFilterButton();
      renderTestimonials();
    });
  }

  if (filter5StarsBtn) {
    filter5StarsBtn.addEventListener('click', () => {
      currentFilter = '5stars';
      visibleCount = 3;
      currentPage = 1;
      updateActiveFilterButton();
      renderTestimonials();
    });
  }

  if (filterProofsBtn) {
    filterProofsBtn.addEventListener('click', () => {
      currentFilter = 'proofs';
      visibleCount = 3;
      currentPage = 1;
      updateActiveFilterButton();
      renderTestimonials();
    });
  }

  // Inicializar render de testimonios
  renderTestimonials();

  // =========================================================================
  // 3. MANEJADOR DEL MODAL DE COMPROBANTE AUDITABLE
  // =========================================================================
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.open-proof-btn');
    if (!btn) return;
    const imgUrl = btn.dataset.img;
    const user = btn.dataset.user || 'AUDITORÍA INSTAPLAY';

    if (proofModal && proofModalImg) {
      proofModalImg.onerror = () => {
        proofModalImg.onerror = null;
        proofModalImg.src = 'https://res.cloudinary.com/afkfwjkg/image/upload/f_auto,q_auto/v1789306843/instaplay_comprobantes/aaovr08lnwpwbch0yab0.jpg';
      };
      proofModalImg.src = imgUrl;
      if (proofModalTitle) {
        proofModalTitle.textContent = `COMPROBANTE_AUDITABLE_${user.toUpperCase().replace(/[\s@_]+/g, '_')}.PNG`;
      }
      proofModal.classList.remove('hidden');
      document.body.classList.add('overflow-hidden');
      document.body.style.overflow = 'hidden';
    }
  });

  if (closeProofModalBtn && proofModal) {
    closeProofModalBtn.addEventListener('click', () => {
      proofModal.classList.add('hidden');
      document.body.classList.remove('overflow-hidden');
      document.body.style.overflow = '';
      if (proofModalImg) proofModalImg.src = '';
    });

    proofModal.addEventListener('click', (e) => {
      if (e.target === proofModal) {
        proofModal.classList.add('hidden');
        document.body.classList.remove('overflow-hidden');
        document.body.style.overflow = '';
        if (proofModalImg) proofModalImg.src = '';
      }
    });
  }

  // =========================================================================
  // 4. CARGA Y RENDER DINÁMICO DE PROMOCIONES ACTIVAS EN INDEX.HTML
  // =========================================================================
  const previousPromoCuposMap = new Map();
  let promoCountdownInterval = null;

  async function loadAndRenderPromotions() {
    const container = document.getElementById('promotions-container');
    if (!container) return;

    try {
      const promos = await fetchPublicPromotions();
      const activePromos = (promos || []).filter(p => p.is_activa || p.is_active);

      if (activePromos.length === 0) {
        container.innerHTML = `
          <div class="col-span-full p-8 text-center win-window bg-[#020d04] border border-[#00ff41]/40 font-mono text-green-400">
            ✓ En este momento no hay promociones activas vigentes. Consulta los planes regulares en WhatsApp.
          </div>
        `;
        return;
      }

      container.innerHTML = activePromos.map(p => {
        const promoPrice = parseFloat(p.precio_promo || 8).toFixed(2);
        const regularPrice = parseFloat(p.precio_regular || 10).toFixed(2);
        const cuposTotales = parseInt(p.cupos_totales, 10) || 25;
        const cuposDisponibles = parseInt(p.cupos_disponibles, 10) || 0;
        const percentLeft = cuposTotales > 0 ? Math.round((cuposDisponibles / cuposTotales) * 100) : 0;
        const codigoCupon = p.codigo_cupon || 'FLASH-8USD';
        const badgeText = p.badge || p.badge_texto || 'PROMO EXCLUSIVA';

        // Lógica de Vigencia / Expiración
        const isExpired = p.fecha_fin ? new Date(p.fecha_fin).getTime() <= Date.now() : false;
        const isAgotado = cuposDisponibles <= 0;
        const isClosed = isExpired || isAgotado;

        // Detección de decremento en tiempo real para animación de urgencia
        const pKey = String(p.id || codigoCupon);
        const prevCupos = previousPromoCuposMap.get(pKey);
        const justConsumed = prevCupos !== undefined && cuposDisponibles < prevCupos;
        previousPromoCuposMap.set(pKey, cuposDisponibles);

        // Mensaje y Enlace de WhatsApp
        let waButtonText = '';
        let defaultWaMsg = '';
        if (isExpired) {
          waButtonText = '⏰ OFERTA EXPIRADA · CONSULTAR PRÓXIMAS FECHAS';
          const expFormatted = new Date(p.fecha_fin).toLocaleDateString();
          defaultWaMsg = `¡Hola InstaPlay! Vi que la promo "${p.titulo}" [Cupón: ${codigoCupon}] venció el ${expFormatted}. ¿Cuándo abrirán nuevos cupos o qué planes tienen disponibles?`;
        } else if (isAgotado) {
          waButtonText = '🚨 CUPOS AGOTADOS · CONSULTAR PRÓXIMA DISPONIBILIDAD';
          defaultWaMsg = `¡Hola InstaPlay! Vi que la promo "${p.titulo}" [Cupón: ${codigoCupon}] está agotada. ¿Cuándo abren nuevos cupos o qué planes tienen disponibles?`;
        } else {
          waButtonText = '💬 RECLAMAR ESTA PROMO POR WHATSAPP';
          defaultWaMsg = `¡Hola InstaPlay! Deseo aprovechar la promo "${p.titulo}" (${badgeText}) a $${promoPrice} USD. Mi código de cupón es: [${codigoCupon}]. Adjunto comprobante de pago.`;
        }
        const waLink = p.link_whatsapp || `https://wa.me/51920271596?text=${encodeURIComponent(defaultWaMsg)}`;

        // Badge de estado
        let statusBadgeHtml = '';
        if (isExpired) {
          statusBadgeHtml = `
            <span class="px-2.5 py-1 bg-red-950 border border-red-500 text-red-300 text-xs font-bold tracking-wider">
              ⏰ OFERTA EXPIRADA
            </span>
            <span class="text-[10px] text-red-400 font-mono">● VENCIDA</span>
          `;
        } else if (isAgotado) {
          statusBadgeHtml = `
            <span class="px-2.5 py-1 bg-red-950 border border-red-500 text-red-300 text-xs font-bold tracking-wider">
              🚨 CUPOS AGOTADOS
            </span>
            <span class="text-[10px] text-red-400 font-mono">● CERRADA</span>
          `;
        } else {
          statusBadgeHtml = `
            <span class="px-2.5 py-1 bg-yellow-950 border border-yellow-500 text-yellow-300 text-xs font-bold tracking-wider">
              ${badgeText}
            </span>
            <span class="text-[10px] text-green-400 font-mono animate-pulse">
              ● EN VIVO
            </span>
          `;
        }

        // Cuenta Regresiva de Vigencia
        let vigenciaCountdownHtml = '';
        if (p.fecha_fin && !isExpired) {
          vigenciaCountdownHtml = `
            <div class="promo-countdown-box p-2 bg-[#00170a] border border-cyan-400/60 flex items-center justify-between gap-2" data-expire="${p.fecha_fin}">
              <div class="flex items-center gap-1.5 text-xs text-cyan-300 font-bold font-mono">
                <span>⏳</span> <span>VENCE EN:</span>
              </div>
              <div class="promo-countdown-timer text-xs sm:text-sm font-bold font-mono text-yellow-300 tracking-wider">
                Calculando...
              </div>
            </div>
          `;
        } else if (isExpired && p.fecha_fin) {
          const expDateStr = new Date(p.fecha_fin).toLocaleString([], { dateStyle: 'short', timeStyle: 'short' });
          vigenciaCountdownHtml = `
            <div class="p-2 bg-red-950/60 border border-red-800 text-[11px] text-red-300 flex items-center justify-between font-mono">
              <span>⏰ Expiró el:</span>
              <span class="font-bold text-red-200">${expDateStr}</span>
            </div>
          `;
        }

        return `
          <div 
            id="promo-${encodeURIComponent(codigoCupon)}" 
            data-promo-coupon="${codigoCupon}" 
            class="win-window flex flex-col justify-between p-6 bg-[#021406] border-2 ${isClosed ? 'border-red-500/60 opacity-90' : 'border-[#00ff41]'} ${justConsumed ? 'ring-4 ring-yellow-400 animate-pulse' : ''} shadow-[0_0_30px_rgba(0,255,65,0.25)] hover:shadow-[0_0_40px_rgba(0,255,65,0.45)] transition-all font-mono group"
          >
            <div class="space-y-4">
              <div class="flex items-center justify-between gap-2 border-b ${isClosed ? 'border-red-500/40' : 'border-[#00ff41]/40'} pb-3">
                ${statusBadgeHtml}
              </div>

              <div>
                <h3 class="pixel-font text-3xl text-white group-hover:text-[#00ff41] transition-colors leading-tight">
                  ${p.titulo}
                </h3>
                <p class="text-xs text-green-200 mt-2 leading-relaxed">
                  ${p.descripcion}
                </p>
              </div>

              <!-- Bloque de Cuenta Regresiva de Vigencia -->
              ${vigenciaCountdownHtml}

              <!-- Cupón Destacado y Acciones de Difusión -->
              <div class="p-2.5 bg-[#001706] border border-[#00ff41]/50 flex items-center justify-between gap-2 flex-wrap">
                <div class="flex items-center gap-1.5 truncate">
                  <span class="text-sm">🎟️</span>
                  <span class="text-[10px] sm:text-xs text-gray-300 font-mono">CÓDIGO:</span>
                  <span class="text-yellow-300 font-bold font-mono tracking-wider text-xs sm:text-sm uppercase">${codigoCupon}</span>
                </div>
                <div class="flex items-center gap-1.5">
                  <button 
                    type="button" 
                    class="copy-promo-coupon-btn px-2 py-1 bg-[#003300] hover:bg-yellow-400 hover:text-black border border-[#00ff41] text-[10px] text-[#00ff41] font-bold cursor-pointer transition-all whitespace-nowrap" 
                    data-code="${codigoCupon}"
                    title="Copiar código de cupón"
                  >
                    📋 COPIAR
                  </button>
                  <button 
                    type="button" 
                    class="share-promo-web-btn px-2 py-1 bg-[#011a28] hover:bg-cyan-400 hover:text-black border border-cyan-400 text-[10px] text-cyan-300 font-bold cursor-pointer transition-all whitespace-nowrap" 
                    data-code="${codigoCupon}"
                    title="Copiar enlace directo de esta promo para compartir"
                  >
                    🔗 LINK
                  </button>
                </div>
              </div>

              <!-- Precios -->
              <div class="p-3 bg-[#010803] border ${isClosed ? 'border-red-900' : 'border-green-900'} flex items-center justify-between">
                <div>
                  <span class="text-[10px] text-gray-400 font-mono block">PRECIO REGULAR</span>
                  <span class="text-sm text-gray-400 line-through font-bold">$${regularPrice} USD</span>
                </div>
                <div class="text-right">
                  <span class="text-[10px] text-[#39ff14] font-mono block font-bold">PRECIO PROMOCIONAL</span>
                  <span class="pixel-font text-3xl sm:text-4xl ${isClosed ? 'text-gray-400' : 'text-[#00ff41] glow-text'} font-bold">$${promoPrice} <span class="text-base ${isClosed ? 'text-gray-500' : 'text-green-400'}">USD</span></span>
                </div>
              </div>

              <!-- Cupos en Tiempo Real -->
              <div class="space-y-1">
                <div class="flex items-center justify-between text-xs ${isClosed ? 'text-red-400' : 'text-green-300'}">
                  <span class="flex items-center gap-1 font-bold">
                    <span>${isClosed ? '⛔' : '🔥'}</span> <span>CUPOS DISPONIBLES:</span>
                  </span>
                  <span class="${isClosed ? 'text-red-400 font-bold' : 'text-yellow-300 font-bold'}">
                    ${cuposDisponibles} de ${cuposTotales} ${isAgotado ? '(AGOTADO)' : (isExpired ? '(VENCIDA)' : '')}
                  </span>
                </div>
                <div class="promo-progress-track ${isClosed ? 'is-closed' : ''}" style="width: 100%; height: 14px; background: #010803; border: 1px solid ${isClosed ? '#ef4444' : 'rgba(0, 255, 65, 0.4)'}; overflow: hidden; position: relative;">
                  <div 
                    class="promo-progress-fill ${isClosed ? 'is-closed' : (percentLeft <= 25 ? 'is-low' : '')}" 
                    style="width: ${isClosed ? '100%' : `${Math.max(percentLeft, 4)}%`}; height: 100%; background: ${isClosed ? '#dc2626' : (percentLeft <= 25 ? 'linear-gradient(90deg, #b45309 0%, #eab308 100%)' : 'linear-gradient(90deg, #15803d 0%, #22c55e 50%, #00ff41 100%)')}; box-shadow: ${isClosed ? '0 0 10px rgba(220, 38, 38, 0.7)' : (percentLeft <= 25 ? '0 0 10px rgba(234, 179, 8, 0.7)' : '0 0 10px rgba(0, 255, 65, 0.7)')}; transition: width 0.5s ease-in-out;"
                  ></div>
                </div>
                ${justConsumed ? '<div class="text-[10px] text-yellow-300 font-mono text-right animate-pulse">⚡ ¡Un usuario acaba de canjear un cupón!</div>' : ''}
              </div>
            </div>

            <!-- Botón WhatsApp -->
            <div class="pt-5 mt-auto">
              <a 
                href="${waLink}" 
                target="_blank" 
                rel="noopener noreferrer"
                class="${isClosed ? 'px-4 py-3 bg-[#150a0a] hover:bg-red-700 text-red-300 hover:text-white border-2 border-red-500' : 'retro-btn-green'} w-full block text-center py-3 text-sm font-bold tracking-wider hover:scale-[1.02] transition-transform flex items-center justify-center gap-2"
              >
                <span>${waButtonText}</span>
              </a>
            </div>
          </div>
        `;
      }).join('');

      // Iniciar el temporizador de cuenta regresiva en vivo cada segundo
      startPromoCountdowns(container);

      // Copiar código de cupón
      container.querySelectorAll('.copy-promo-coupon-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const code = btn.dataset.code;
          if (!code) return;
          navigator.clipboard.writeText(code).then(() => {
            const originalText = btn.innerHTML;
            btn.innerHTML = '¡COPIADO! ✅';
            btn.classList.add('bg-yellow-400', 'text-black');
            setTimeout(() => {
              btn.innerHTML = originalText;
              btn.classList.remove('bg-yellow-400', 'text-black');
            }, 2000);
          }).catch(() => {
            alert(`Código de cupón: ${code}`);
          });
        });
      });

      // Copiar enlace directo a la promo para compartir
      container.querySelectorAll('.share-promo-web-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const code = btn.dataset.code;
          if (!code) return;
          const shareUrl = `${window.location.origin}/?promo=${encodeURIComponent(code)}#promociones`;
          navigator.clipboard.writeText(shareUrl).then(() => {
            const originalText = btn.innerHTML;
            btn.innerHTML = '¡LINK COPIADO! 🔗';
            btn.classList.add('bg-cyan-400', 'text-black');
            setTimeout(() => {
              btn.innerHTML = originalText;
              btn.classList.remove('bg-cyan-400', 'text-black');
            }, 2000);
          }).catch(() => {
            prompt('Copia este enlace directo de la promoción:', shareUrl);
          });
        });
      });

      // Auto-detección y scroll automático si se ingresa con ?promo=, ?cupon= o #promo-
      const urlParams = new URLSearchParams(window.location.search);
      const targetCoupon = (urlParams.get('promo') || urlParams.get('cupon') || (window.location.hash.startsWith('#promo-') ? window.location.hash.replace('#promo-', '') : '')).trim().toUpperCase();
      if (targetCoupon) {
        setTimeout(() => {
          const targetCard = container.querySelector(`[data-promo-coupon="${targetCoupon}"]`);
          if (targetCard) {
            targetCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
            targetCard.classList.add('ring-4', 'ring-yellow-400', 'shadow-[0_0_50px_rgba(250,204,21,0.6)]');
            setTimeout(() => {
              targetCard.classList.remove('ring-4', 'ring-yellow-400', 'shadow-[0_0_50px_rgba(250,204,21,0.6)]');
            }, 4000);
          }
        }, 500);
      }
    } catch (err) {
      console.error('Error al renderizar promociones en home:', err);
    }
  }

  // Actualizador de cuenta regresiva en vivo segundo a segundo
  function startPromoCountdowns(container) {
    if (promoCountdownInterval) {
      clearInterval(promoCountdownInterval);
    }

    function tick() {
      const countdownBoxes = container.querySelectorAll('.promo-countdown-box');
      let needsRerender = false;

      countdownBoxes.forEach(box => {
        const expireIso = box.dataset.expire;
        const timerEl = box.querySelector('.promo-countdown-timer');
        if (!expireIso || !timerEl) return;

        const diff = new Date(expireIso).getTime() - Date.now();
        if (diff <= 0) {
          timerEl.textContent = '00d 00h 00m 00s (VENCIDO)';
          needsRerender = true;
        } else {
          const days = Math.floor(diff / 86400000);
          const hours = Math.floor((diff % 86400000) / 3600000);
          const mins = Math.floor((diff % 3600000) / 60000);
          const secs = Math.floor((diff % 60000) / 1000);
          const pad = (n) => String(n).padStart(2, '0');
          timerEl.textContent = `${days}d ${pad(hours)}h ${pad(mins)}m ${pad(secs)}s`;
        }
      });

      if (needsRerender) {
        clearInterval(promoCountdownInterval);
        loadAndRenderPromotions();
      }
    }

    tick();
    promoCountdownInterval = setInterval(tick, 1000);
  }

  // Carga inicial
  loadAndRenderPromotions();

  // =========================================================================
  // SINCRONIZACIÓN EN TIEMPO REAL EN LA WEB (CROSS-TAB & SUPABASE REALTIME)
  // =========================================================================
  subscribePromotionsLocalSync(async (detail) => {
    console.log('🔄 Home Web: Notificación de cupón consumido o promo modificada:', detail);
    await loadAndRenderPromotions();
  });

  subscribeToPromotionsRealtime(async (payload) => {
    console.log('📡 Home Web: Evento Realtime recibido de Supabase promociones:', payload);
    await loadAndRenderPromotions();
  });

  // Polling de respaldo inteligente cada 20s cuando el usuario está viendo la página
  setInterval(() => {
    if (document.visibilityState === 'visible') {
      loadAndRenderPromotions();
    }
  }, 20000);

  // =========================================================================
  // 5. HERO ACCOUNT BUILDER (MEJORAS Y CÁLCULO EN VIVO DE PRECIO & WHATSAPP)
  // =========================================================================
  function initHeroAccountBuilder() {
    const chkSalsa = document.getElementById('hero-addon-salsanow');
    const chkStorage = document.getElementById('hero-addon-storage');
    const chkHours = document.getElementById('hero-addon-hours');
    const chkCombo = document.getElementById('hero-addon-combo');
    const priceDisplay = document.getElementById('hero-price-display');
    const planSummary = document.getElementById('hero-plan-summary');
    const ctaBtn = document.getElementById('hero-cta-btn');
    const strikePrice = document.getElementById('hero-strike-price');
    const tagDiscount = document.getElementById('hero-tag-discount');

    if (!priceDisplay || !ctaBtn) return;

    function recalculate() {
      const baseCost = 10;
      let addonCost = 0;
      const selectedAddons = [];

      if (chkCombo && chkCombo.checked) {
        addonCost = 9;
        selectedAddons.push('Combo All-in-One VIP');
        if (chkSalsa) chkSalsa.checked = true;
        if (chkStorage) chkStorage.checked = true;
        if (chkHours) chkHours.checked = true;
      } else {
        const salsa = chkSalsa && chkSalsa.checked;
        const storage = chkStorage && chkStorage.checked;
        const hours = chkHours && chkHours.checked;

        if (salsa && storage && hours) {
          if (chkCombo) chkCombo.checked = true;
          addonCost = 9;
          selectedAddons.push('Combo All-in-One VIP');
        } else {
          if (salsa) {
            addonCost += 2;
            selectedAddons.push('SalsaNow (+ $2)');
          }
          if (storage) {
            addonCost += 4;
            selectedAddons.push('1TB Almacenamiento (+ $4)');
          }
          if (hours) {
            addonCost += 5;
            selectedAddons.push('+50 Horas/Mes (+ $5)');
          }
        }
      }

      const total = baseCost + addonCost;
      priceDisplay.innerHTML = `$${total}<span class="text-xl sm:text-2xl text-green-300"> USD</span>`;

      if (strikePrice && tagDiscount) {
        const originalValue = 25 + (addonCost > 0 ? (chkCombo && chkCombo.checked ? 11 : addonCost) : 0);
        strikePrice.textContent = `$${originalValue}`;
        const discountPct = Math.round((1 - (total / originalValue)) * 100);
        tagDiscount.textContent = `-${discountPct}% OFF`;
      }

      let summaryText = '// CUENTA BASE (100h / 100 GB OFICIALES)';
      let waAddonsText = 'Plan Base';

      if (selectedAddons.length > 0) {
        summaryText = `// CUENTA PERSONALIZADA: ${selectedAddons.join(', ')}`;
        waAddonsText = `Plan Base + ${selectedAddons.join(' + ')}`;
      }
      if (planSummary) {
        planSummary.textContent = summaryText;
      }

      ctaBtn.textContent = `► INICIAR MI MES DE JUEGO AHORA ($${total} USD)`;
      const waMsg = `Hola InstaPlay! Quiero iniciar mi mes de juego por $${total} USD (${waAddonsText})`;
      ctaBtn.href = `https://wa.me/51920271596?text=${encodeURIComponent(waMsg)}`;
    }

    if (chkCombo) {
      chkCombo.addEventListener('change', () => {
        if (!chkCombo.checked) {
          if (chkSalsa) chkSalsa.checked = false;
          if (chkStorage) chkStorage.checked = false;
          if (chkHours) chkHours.checked = false;
        }
        recalculate();
      });
    }

    [chkSalsa, chkStorage, chkHours].forEach(chk => {
      if (chk) {
        chk.addEventListener('change', () => {
          if (!chk.checked && chkCombo && chkCombo.checked) {
            chkCombo.checked = false;
          }
          recalculate();
        });
      }
    });

    recalculate();
  }

  initHeroAccountBuilder();
});

